import ContentService from '@/services/api/content/content-service';
import LanguageService from '@/services/language/language-service';

const state = {
  loadingProfile: true,
  content: [],
};

const getters = {
  loadingProfile: state => state.loadingProfile,
  contentById: state => syncguid => {
    return state.content.find(c => c.syncguid === syncguid);
  },
};

const mutations = {
  setLoadingProfile(state, loading) {
    state.loadingProfile = !!loading;
  },
  createContentObject(state, syncguid) {
    state.content.push({ syncguid });
  },
  setContentValue(state, { syncguid, key, value }) {
    const found = state.content.find(c => c.syncguid === syncguid);
    found[key] = value;
  },
};

const actions = {
  loadProfile({ commit, dispatch, getters }, syncguid) {
    commit('setLoadingProfile', true);
    const found = getters.contentById(syncguid);
    if (found) {
      commit('setLoadingProfile', false);
      return found;
    }
    commit('createContentObject', syncguid);
    return Promise.all([
      dispatch('getProfile', syncguid),
      dispatch('getThumbnail', syncguid),
      dispatch('getSupportMaterials', syncguid),
      dispatch('getInteractions', syncguid),
      dispatch('getResources', syncguid),
      dispatch('getQuiz', syncguid),
      dispatch('getCaptions', syncguid),
    ]).catch(() => {
      commit('setError', 'There was an error loading your content! Please refresh and try again');
    }).finally(() => {
      commit('setLoadingProfile', false);
    });
  },
  getProfile({ commit }, syncguid) {
    return ContentService.getContentById(syncguid).then(value => {
      commit('setContentValue', { syncguid, key: 'profile', value });
    });
  },
  getThumbnail({ commit }, syncguid) {
    return ContentService.getThumbnail(syncguid).then(value => {
      commit('setContentValue', { syncguid, key: 'thumbnail', value });
    });
  },
  getSupportMaterials({ commit }, syncguid) {
    return ContentService.getSupportMaterials(syncguid).then(value => {
      commit('setContentValue', { syncguid, key: 'materials', value });
    });
  },
  getInteractions({ commit }, syncguid) {
    return ContentService.getInteractions(syncguid).then(value => {
      commit('setContentValue', { syncguid, key: 'interactions', value });
    });
  },
  getResources({ commit }, syncguid) {
    return ContentService.getResources(syncguid).then(value => {
      commit('setContentValue', { syncguid, key: 'resources', value });
    });
  },
  getQuiz({ commit }, syncguid) {
    return ContentService.getQuiz(syncguid).then(value => {
      if (Object.keys(value).length > 0) {
        value.questions.forEach(question => {
          question.choices = question.choices.map(choice => {
            return {
              ...choice,
              selected: false,
            };
          });
        });
      };
      commit('setContentValue', { syncguid, key: 'quiz', value });
    });
  },
  getCaptions({ commit }, syncguid) {
    return ContentService.getCaptions(syncguid).then(value => {
      if (value && value.length > 0) {
        value = value.map(caption => {
          return {
            label: LanguageService.getDisplayName(caption.language),
            language: caption.language.split('-')[0],
            cues: caption.data,
          };
        });
        // Sort alphabetically by language and move English to the top
        value.sort((lang1, lang2) => {
          if (lang1.language === 'en') {
            return -1;
          } else if (lang2.language === 'en') {
            return 1;
          }
          return lang1.label.toLowerCase().localeCompare(lang2.label.toLowerCase());
        });
      }
      commit('setContentValue', { syncguid, key: 'captions', value });
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
